// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .finish-disc[data-v-2c14f3aa]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
